import {Store} from 'vuex';
import VueRouter from 'vue-router';
import {authService} from '@/auth/AuthServiceInst'

export default class UserService {


    constructor(
        private store: Store<any>,
        private cookie: any,
        private router: VueRouter
    ) {
        this.init();
    }

    public init(): void {
        if (!this.store.getters.user && !this.store.getters.logon) {
            this.retrieveUser();
        }
    }

    public async retrieveUser(): Promise<void> {
        this.store.commit('authenticate');

        const user = authService.getAccount();
        if (user) {
            this.store.commit('authenticated', user);
            if (sessionStorage.getItem('requested-url')) {
                this.router.replace(sessionStorage.getItem('requested-url'));
                sessionStorage.removeItem('requested-url');
            }
        } else {
            this.store.commit('logout');
            sessionStorage.removeItem('requested-url');
        }

    }

    public hasAnyAuthority(authorities: any): boolean {
        if (typeof authorities === 'string') {
            authorities = [authorities];
        }
        if (!this.authenticated || !this.userAuthorities) {
            return false;
        }

        for (let i = 0; i < authorities.length; i++) {
            if (this.userAuthorities.includes(authorities[i])) {
                return true;
            }
        }

        return false;
    }

    public isCurrentUser(login: string): boolean {
        if (login == undefined) {
            return false
        }
        if (!this.authenticated || this.userLogin == null) {
            return false;
        }

        return login == this.userLogin;
    }

    public get authenticated(): boolean {
        return this.store.getters.authenticated;
    }

    public get userAuthorities(): any {
        if (this.store.getters.user) {
            return this.store.getters.user.idTokenClaims.roles;
        } else {
            return [];
        }
    }

    public get userLogin(): string {
        if (this.store.getters.user) {
            return this.store.getters.user.login;
        } else {
            return null;
        }
    }
}
